export const PUBLIC_PAGE_METADATA = {
  '/': {
    title: 'WebForms.biz – Take Control of Your Web Forms | Professional Form Builder',
    description: 'Build, test, and publish forms with analytics, payments, integrations, and A/B testing. Start free with WebForms.biz.',
    includeFaqSchema: true,
  },
  '/pricing': {
    title: 'WebForms.biz Pricing | Transparent Form Builder Plans',
    description: 'Compare WebForms.biz plans with clear form, submission, seat, storage, and feature limits. Start free, or save with annual billing.',
    includeFaqSchema: true,
  },
  '/features': {
    title: 'WebForms.biz Features | Forms, Analytics, Payments, and More',
    description: 'Explore WebForms.biz features for building, publishing, analyzing, and optimizing forms without waiting for engineering support.',
  },
  '/customers': {
    title: 'WebForms.biz Workflows | Forms for Marketing, Agencies, and Operations',
    description: 'See how marketing, agency, and operations teams can use WebForms.biz to build forms, collect responses, and improve workflows.',
  },
  '/about': {
    title: 'About WebForms.biz | Form Building for Growing Teams',
    description: 'Learn why WebForms.biz gives marketing, sales, operations, and agency teams one place to build, publish, and improve forms.',
  },
  '/terms': {
    title: 'Terms of Service | WebForms.biz',
    description: 'Read the WebForms.biz Terms of Service for the form-building platform, subscriptions, content, and acceptable use.',
  },
  '/privacy': {
    title: 'Privacy Policy | WebForms.biz',
    description: 'Read how WebForms.biz collects, uses, protects, and processes account data and form submissions.',
  },
  '/templates-gallery': {
    title: 'Form Templates Gallery | WebForms.biz',
    description: 'Browse professionally designed WebForms.biz templates for contact forms, lead capture, surveys, bookings, payments, and more.',
  },
};
